"use client";
import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { CommandTerm } from "@tsTypes/command-term-schema";
import { useState } from "react";
import TermsGridLayout from "../../../(withSyllabusBar)/definitions/[topic]/components/TermsGridLayout";
import LinkedUsefulResourceBanner from "../../../components/banners/LinkedUsefulResourceBanner";
import SearchInputWithCount from "../../../components/search/SearchInputWithCount";

export default function CommandTermsLayout({
  commandTerms,
  subjectNameLower,
}: {
  commandTerms: CommandTerm[];
  subjectNameLower: string;
}) {
  const [search, setSearch] = useState("");

  const filteredTerms = commandTerms.filter((d) =>
    d.Term.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <SearchInputWithCount
        placeholder="Search command terms..."
        value={search}
        onChange={(event) => setSearch(event.currentTarget.value)}
        count={filteredTerms.length}
      />

      <TermsGridLayout
        type="command term"
        definitions={filteredTerms}
        subjectColorIndex={getSubjectColorIndex(subjectNameLower)}
      />

      <LinkedUsefulResourceBanner
        subject={subjectNameLower}
        currentResource={"command terms"}
        linkedResource={"exam breakdown"}
      />
    </>
  );
}
